module.exports = __webpack_public_path__ + "img/hip.9aa9a0e6.jpg";